import React, {useState} from 'react';
import { Button, SvgIcon } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import SubmitCaseIcon from '../../icons/submit a case.svg';
import Dollar2Icon from '../../icons/Dollar2.svg';
import { checkDisabledFields, checkHiddenFields } from '../Helpers/CheckAccess';
import { getSessionStorageItem, ADVISOR_OBJECT_KEY, ADVISOR_BASIC_INFO_KEY, ACTIVITY_OBJECT_KEY } from '../../sessionStorage';
import RequestSession from '../Common/RequestSession';

const useStyles = makeStyles(theme => ({
  headerLink: {
    fontSize: '1rem',
    textTransform: 'uppercase',
    letterSpacing: '.5px',
    fontWeight: 'bold',
    marginLeft: '.75em',
    '&:hover': {
      color: theme.palette.primary.main,
    }
  },
  svgSize: {
    width: '2.5rem',
    height: '2rem'
  }
}));

export default function ActionButtons() {
  const headerLink = useStyles().headerLink;
  const svgSize = useStyles().svgSize;

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [selectedLink, setSelectedLink] = useState('');
    const [selectedSessionKey, setSelectedSessionKey] = useState('');

  var advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
  var role = advisorObj && advisorObj.role;

  const links = [
    // {
    //   name: 'Request an Illustration',
    //   icon: Dollar2Icon,
    //   href: '/Activity/Illustration',
    //   isHide: checkHiddenFields(role, "illustration"),
    //   isDisabled: checkDisabledFields(role, "illustration"),
    //   sessionKey : ADVISOR_BASIC_INFO_KEY
    // },
    // {
    //   name: 'Submit a Case',
    //   icon: SubmitCaseIcon,
    //   href: '/Activity/NewCase',
    //   isHide: checkHiddenFields(role, "illustration"),
    //   isDisabled: checkDisabledFields(role, "illustration"),
    //   sessionKey : ACTIVITY_OBJECT_KEY
    // },
  ];

  const checkSessionValue = (sessionKey, href) => {
    var sessionItem = getSessionStorageItem(sessionKey);
    if(sessionItem) {
      setSelectedLink(href);
      setSelectedSessionKey(sessionKey);
      handleShow();
    }
    else{
      setSelectedLink('');
      setSelectedSessionKey('');
      window.location.href = href;
    }
  }

  const headerLinks = links.filter((link) => !link.isHide);
  const actionButtons = headerLinks.map((h, i) =>
    <Button
      key={i}
      variant="text"
      color="primary"
      className={`${headerLink}`}
      disabled={h.isDisabled}
      onClick={()=> checkSessionValue(h.sessionKey, h.href)}>
      <SvgIcon className={svgSize} component={h.icon} color="primary" viewBox="0 0 30 30" />&nbsp;{h.name}
    </Button>
  );
  return(
    <React.Fragment>
      {actionButtons}
      <RequestSession
        show={show}
        onHide={() => handleClose()}
        sessionKey= {selectedSessionKey}
        href={selectedLink}
      />
    </React.Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/Common/ActionButtons.js